// eslint-disable-next-line import/no-extraneous-dependencies
import styled, { css } from 'styled-components';
/**
 * Barra de progresso indeterminada no padrão do Celebration: trilho
 * `neutral-200` e indicador na cor de ação. Usada no loading de abertura e na
 * troca de módulo. O splash do `index.html` repete estes valores.
 */
export const indeterminateBar = css `
  position: relative;
  overflow: hidden;
  background-color: var(--color-neutral-200);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 40%;
    border-radius: inherit;
    background-color: var(--color-action-default);
    animation: root-app_bar 1.4s cubic-bezier(0.48, 0, 0.48, 1) infinite;
  }

  @keyframes root-app_bar {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(250%);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    &::before {
      width: 100%;
      animation: none;
    }
  }
`;
export const visuallyHidden = css `
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
`;
/** Logo da Cora "respirando" e a barra — iguais na abertura e na troca de tela. */
const coraLoadingContent = css `
  .root-app_loading-logo {
    width: 160px;
    height: auto;
    animation: root-app_breathe 2s cubic-bezier(0.48, 0, 0.48, 1) infinite;
  }

  .root-app_loading-bar {
    ${indeterminateBar}
    width: 160px;
    height: 4px;
    border-radius: var(--border-radius-pill);
  }

  .root-app_loading-label {
    ${visuallyHidden}
  }

  @keyframes root-app_breathe {
    0%,
    100% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.72;
      transform: scale(0.96);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .root-app_loading-logo {
      animation: none;
    }
  }
`;
export const LoadingContainer = styled.div `
  /*
   * Sem fade-in: o splash do index.html é idêntico e sai no primeiro quadro do
   * React, então qualquer transparência aqui deixa ver o layout de trás — o
   * menu V1 (a barra preta), que é o padrão até o manifesto dizer a versão.
   */
  .root-app_loading-container {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--color-neutral-background);
  }

  .root-app_loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--spacing-size-xs);
  }

  ${coraLoadingContent}
`;
/**
 * Loading da troca de tela: cobre só o palco (`#root-app_side_content`), por
 * cima do iframe, e deixa o menu à vista.
 */
export const StageLoadingContainer = styled.div `
  position: absolute;
  z-index: 1;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-size-xs);
  background-color: var(--color-neutral-background);

  ${coraLoadingContent}
`;
//# sourceMappingURL=style.js.map